module.exports = __webpack_public_path__ + "static/media/dm_black.4e786f28.svg";